import { Spin } from "antd";
import { PERMISSIONS } from "common/constants";
import { useAuthContext } from "common/contexts/AuthContext";
import { useCartContext } from "common/contexts/CartContext";
import activeImage from "common/icons/activeCartGreen.svg";
import image from "common/icons/cartGreen.svg";
import { useTranslation } from "react-i18next";
import { Link, useMatch } from "react-router-dom";
import styled from "styled-components";
import HeaderLink from "./HeaderLink";

const StyledSpin = styled(Spin)`
  width: 170px;
  align-self: center;
  border-left: 1px solid rgba(0, 87, 84, 0.1);
`;

const CartHeader = () => {
  const { parsedRoleConfig } = useAuthContext();
  const { t } = useTranslation();
  const isCartPage = useMatch("/cart");
  const {
    cartDetails = [],
    cartIsLoading,
    cartIsFetching,
    cartIsRefetching
  } = useCartContext();

  if (parsedRoleConfig?.Cart.indexOf(PERMISSIONS.create) < 0) {
    return null;
  }

  if (cartIsLoading || cartIsFetching || cartIsRefetching) {
    return <StyledSpin />;
  }

  return (
    <Link to="/cart">
      <HeaderLink
        image={image}
        activeImage={activeImage}
        match={isCartPage}
        active={cartDetails?.length > 0}
        text={`${t("cart")} ${
          cartDetails?.length > 0
            ? cartDetails.flatMap((cart) => cart.inventory).length
            : ""
        }`}
      />
    </Link>
  );
};

export default CartHeader;
